import apiClient from './client';

export const listMessages = (params) => apiClient.get('/communication', { params }).then((r) => r.data);
export const sendMessage = (payload) => apiClient.post('/communication', payload).then((r) => r.data);
